export default "__VITE_ASSET__DgoltR6$__"